module.exports = __webpack_public_path__ + "static/fonts/songSemiBold.3cec8b39.otf";